module.exports = __webpack_public_path__ + "img/file-code.b112c18.svg";